import React from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

/**
 * Botón compartido para mostrar u ocultar el detalle de una fila de tabla.
 * Incluye un tooltip de MUI y un icono que cambia según el estado de expansión.
 *
 * Datos que recibe:
 * - `expanded` (por defecto `false`): estado controlado por la pantalla; cambia
 *   el icono y el atributo aria-expanded. No modifica el estado por sí mismo.
 * - `label`: texto del tooltip y nombre accesible del botón. Si se omite, usa
 *   «Mostrar detalle» o «Ocultar detalle» según el estado de expansión.
 * - `onClick(event)`: acción al pulsar el botón; la pantalla debe actualizar
 *   el estado de expansión y renderizar el detalle de la fila.
 *
 * Los estilos están en src/css/components/TableExpandButton.scss.
 *
 * Ejemplo:
 *   <TableExpandButton
 *     expanded={abierto}
 *     label={abierto ? 'Ocultar cobros' : 'Ver cobros'}
 *     onClick={() => setAbierto((actual) => !actual)}
 *   />
 */
export default function TableExpandButton({ expanded = false, label, onClick }) {
  const resolvedLabel = label || (expanded ? 'Ocultar detalle' : 'Mostrar detalle')

  return (
    <Tooltip title={resolvedLabel} placement="top" arrow describeChild>
      <IconButton
        className="table-expand-button"
        size="small"
        disableRipple
        disableFocusRipple
        aria-label={resolvedLabel}
        aria-expanded={expanded}
        onClick={onClick}
      >
        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </IconButton>
    </Tooltip>
  )
}
